export class Point2D {
    x;
    y;
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    toString() {
        return `Point2D:{ x:${this.x}, y:${this.y} }`;
    }
    equals(o) {
        if (o != null) {
            return o.x === this.x && o.y === this.y;
        }
        return false;
    }
    compareTo(o) {
        let result = this.y - o.y;
        if (result === 0.0) {
            result = this.x - o.x;
        }
        return result < 0 ? -1 : result > 0 ? +1 : 0;
    }
    compare(o0, o1) {
        let result = o0.y - o1.y;
        if (result === 0.0) {
            result = o0.x - o1.x;
        }
        return result < 0 ? -1 : result > 0 ? +1 : 0;
    }
}
export class LatLng {
    lat;
    lng;
    constructor(lat, lng) {
        this.lat = lat;
        this.lng = lng;
    }
    toString() {
        return `LatLng:{ lat:${this.lat}, lng:${this.lng} }`;
    }
    equals(o) {
        if (o != null) {
            return o.lat === this.lat && o.lng === this.lng;
        }
        return false;
    }
    compareTo(o) {
        let result = this.lat - o.lat;
        if (result === 0.0) {
            result = this.lng - o.lng;
        }
        return result < 0 ? -1 : result > 0 ? +1 : 0;
    }
    compare(o0, o1) {
        let result = o0.lat - o1.lat;
        if (result === 0.0) {
            result = o0.lng - o1.lng;
        }
        return result < 0 ? -1 : result > 0 ? +1 : 0;
    }
}
export var Hemisphere;
(function (Hemisphere) {
    Hemisphere["North"] = "N";
    Hemisphere["South"] = "S";
})(Hemisphere || (Hemisphere = {}));
